import styled from 'styled-components'
import { white } from '@bufferapp/ui/style/colors'

import { LABELS } from '~/app/constants'
import { flexRow } from '~/shared/styles/layout'

/**
 *
 */

// @ts-expect-error TS(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
const getLabelColor = (type) => {
  const label = LABELS.find((el) => el.id === type)

  if (label) {
    return label.color
  } else {
    return white
  }
}

export const Wrapper = styled.div`
  background-color: ${(props) =>
    getLabelColor(
      // @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
      props.type,
    )};
  width: 16px;
  height: 16px;
  border-radius: 4px;
  ${flexRow}
  justify-content: center;
  align-items: center;
`

export const IconWrapper = styled.div`
  color: ${white};
  ${flexRow}
  justify-content: center;
  align-items: center;

  svg {
    width: 10px;
    height: 10px;
  }
`
